import {
  BellRing, Building2, Clock, Code2, CreditCard, Database, Gauge, Globe2, Users, Volume2,
} from "lucide-react";

// أقسام لوحة النظام: كل قسم يحمّل نداءاته فقط عند فتحه.
export const SYSTEM_SECTIONS = [
  { key: "code", icon: Code2, loads: ["code"] },
  { key: "performance", icon: Gauge, loads: ["performance", "trends"] },
  { key: "storage", icon: Database, loads: ["storage"] },
  { key: "sessions", icon: Users, loads: ["sessions", "revocations"] },
  { key: "crons", icon: Clock, loads: ["crons", "notifyHealth"] },
  { key: "alerts", icon: BellRing, loads: ["alerts", "thresholds"] },
  { key: "usage", icon: Building2, loads: ["companies"] },
  { key: "geo", icon: Globe2, loads: ["geo", "integrations"] },
  { key: "voice", icon: Volume2, loads: [] },
  { key: "payments", icon: CreditCard, loads: [] },
];

export const SYSTEM_KEYS = SYSTEM_SECTIONS.map((section) => section.key);

export const loadsOf = (key) =>
  (SYSTEM_SECTIONS.find((section) => section.key === key) || SYSTEM_SECTIONS[0]).loads;
